import { Link } from "react-router-dom";

export const Footer = () => (
    <footer className="kf-footer border-top text-secondary small">
        <div className="container text-center">
            <nav aria-label="Footer" className="d-flex justify-content-center flex-wrap column-gap-4 row-gap-1 mb-3">
                <Link to="/">Home</Link>
                <Link to="/submit-retailer">Submit retailer</Link>
                <Link to="/contact">Contact</Link>
            </nav>
            <div>
                &copy; {new Date().getFullYear()} KegFinder. A side project by{" "}
                <a href="https://ben.bristow.me" rel="noopener noreferrer" target="_blank">Ben Bristow</a>
            </div>
            <p className="kf-footer__disclaimer mt-2 mb-0">
                KegFinder is an independent community directory and is not affiliated with, endorsed, or sponsored by Heineken (Blade&reg;), AB InBev (PerfectDraft&reg;), or any retailers listed.
            </p>
        </div>
    </footer>
);